const UseCheckIsFreeUser = (id) => {
  if ("1dff1167-8e08-4020-a91f-2410805aad63" === id) {
    return true;
  } else {
    return false;
  }
};

export default UseCheckIsFreeUser;
